import type { PriceId } from '@iheartjane/types';

import type { AlgoliaProduct } from '@jane/search/types';
// eslint-disable-next-line no-restricted-imports
import type { BrandSpecialPrices, MenuProduct } from '@jane/shared/models';
import type { MaterializedMenuProduct } from '@jane/shared/types';

import { priceIdsHaveOneDiscount } from './janeGoldTags/util';

type GetIfAllPriceIdsShareDiscountProps = {
  brandSpecials?: BrandSpecialPrices;
  menuProduct?: MenuProduct | AlgoliaProduct | MaterializedMenuProduct;
  priceIds?: PriceId[];
} & (
  | {
      brandSpecials: BrandSpecialPrices;
      menuProduct?: never;
      priceIds: PriceId[];
    }
  | {
      brandSpecials?: never;
      menuProduct: MenuProduct | AlgoliaProduct | MaterializedMenuProduct;
      priceIds?: never;
    }
);

/**
 * This function returns true/false depending on if every available weight shares a discount id.
 * It can be passed an entire menuProduct, or it can be passed the brand specials and price ids separately.
 */
export const getIfAllPriceIdsShareDiscount = ({
  brandSpecials,
  menuProduct,
  priceIds,
}: GetIfAllPriceIdsShareDiscountProps) => {
  const brandSpecialPrices = menuProduct
    ? menuProduct.brand_special_prices
    : brandSpecials;

  const availableWeights = menuProduct
    ? ((Array.isArray(menuProduct.available_weights)
        ? (menuProduct.available_weights as string[]).map((weight) =>
            weight.replace(' ', '_')
          )
        : []) as PriceId[])
    : priceIds;

  if ((menuProduct && !menuProduct.has_brand_discount) || !brandSpecialPrices)
    return false;

  // If availableWeights is an empty array, the item is sold as each, not by weight;
  // so we just check that there's a special for "each"
  if (availableWeights.length === 0) return !!brandSpecialPrices?.each;

  return priceIdsHaveOneDiscount(availableWeights, brandSpecialPrices);
};
